// Laad Swiper.js dynamisch
function loadSwiperScript() {
	return new Promise((resolve) => {
		if (typeof Swiper !== 'undefined') {
			resolve();
			return;
		}
		
		const script = document.createElement('script');
		script.src = 'https://unpkg.com/swiper@9/swiper-bundle.min.js';
		script.onload = () => {
			// Laad ook CSS
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = 'https://unpkg.com/swiper@9/swiper-bundle.min.css';
			document.head.appendChild(link);
			resolve();
		};
		document.head.appendChild(script);
	});
}

// Initialiseer de slider wanneer Swiper geladen is
loadSwiperScript().then(() => {
	const drSwiper = new Swiper(".mySwiper", {
		slidesPerView: 3,
		spaceBetween: 25,
		loop: false,
		watchOverflow: true,
		allowTouchMove: false, // Geen swipe op desktop
		pagination: {
			el: ".swiper-pagination",
			clickable: true
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev"
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides: false,
				allowTouchMove: true // Wel swipe op mobiel
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20,
				allowTouchMove: false // Geen swipe op desktop
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 25,
				allowTouchMove: false // Geen swipe op desktop
			}
		}
	});
	
	// Maak drSwiper globaal beschikbaar voor onclick handlers
	window.drSwiper = drSwiper;
});
